<template>
  <form v-if="!isHistoricalAccess" enctype="multipart/form-data" novalidate class="uploader-form" :class="{
    'dragging': dragging,
    'inactive': isOfficeLogin
  }" @dragover.prevent="OnDragOver" @dragleave.prevent="OnDragLeave">
    <input type="file" value title=" " accept=".pdf, .jpg, .jpeg, .png, .bmp, .doc, .docx, .zip, .rar, .xls, .xlsx"
      multiple class="uploader-form__action" @change="chooseFiles" />
    <div class="uploader-form__content">
      <img class="uploader-form__content-icon--disabled" v-if="isOfficeLogin"
        src="@/assets/images/icons/i_homework-upload.svg" />
      <img class="uploader-form__content-icon" v-else src="@/assets/images/icons/i_homework-upload.svg" />
      <template v-if="dragging">
        <span class="uploader-form__content-title" :class="{ 'inactive': isOfficeLogin }">{{
          $t('uploader.form.dragging')
          }}</span>
        <span class="uploader-form__content-subtitle" :class="{ 'inactive': isOfficeLogin }">{{
          $t('uploader.form.action')
        }}</span>
      </template>
      <template v-else>
        <span class="uploader-form__content-title" :class="{ 'inactive': isOfficeLogin }">{{ $t('uploader.form.title')
          }}</span>
        <span class="uploader-form__content-subtitle" :class="{ 'inactive': isOfficeLogin }">{{
          $t('uploader.form.action')
        }}</span>
      </template>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import ErrorToast from '../Toasts/ErrorToast.vue';
// eslint-disable-next-line

export default {
  data() {
    return {
      dragging: false,
      draggingCount: 0,
      filesToUpload: [],
      currentSize: 0,
    };
  },

  props: {
    currentFilesSize: {
      type: Number,
      default: null,
    },
  },

  computed: {
    ...mapGetters('auth', ['isOfficeLogin']),
    ...mapState('students', ['student']),
    isHistoricalAccess() {
      return this.student?.isArchived;
    },
  },

  methods: {
    async errorSizeToast() {
      this.$toast({
        component: ErrorToast,
        props: {
          title: 'Przekroczono maksymalny łączny rozmiar plików: 25 MB',
          description: 'Ostatni plik nie został wgrany. Usuń część plików lub zmniejsz ich rozmiar',
        },
      }, {
        type: 'error',
      });
    },

    fileIsValid(file) {
      this.filesToUpload.push(file);
      this.$emit('chosen', this.filesToUpload);
      this.filesToUpload = [];
    },
    formatFileSize(fileSize) {
      const fileExtension = ['Bytes', 'KB', 'MB', 'GB'];
      let i = 0;
      while (fileSize > 900) {
        fileSize /= 1024; // eslint-disable-line no-param-reassign
        i += 1;
      }
      return `${Math.round(fileSize * 100) / 100} ${fileExtension[i]}`;
    },

    chooseFiles(e) {
      const { files } = e.target;
      const filesSize = [...files].map(file => file.size).reduce((a, b) => a + b, 0);
      const limitSize = process.env.VUE_APP_UPLOAD_LIMIT;
      if (filesSize + this.currentFilesSize > limitSize) {
        this.errorSizeToast();
        return;
      }
      this.dragging = false;
      Array.from(files).forEach(file => this.fileIsValid(file));
      e.target.value = '';
    },

    OnDragOver(e) {
      this.dragging = true;
      this.draggingCount = e.dataTransfer.items.length;
    },

    OnDragLeave() {
      this.dragging = false;
      this.draggingCount = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
input[type="file"] {
  cursor: pointer;
}

.uploader-form {
  @apply relative w-full py-8 px-6 text-center;
  background-color: rgba(#ec268f, 0.05);
  border-radius: 20px;
  border: 0;
  border: 2px dashed var(--pink-500, #E10A7B);
  border-radius: 20px;
  transition: 0.5s all;

  &.inactive {
    pointer-events: none;
    border: 2px dashed rgba($color: #1b181a, $alpha: .25);
    background-color: rgb(232, 232, 232);
  }

  &.dragging {
    border: 2px dashed var(--pink-500, #E10A7B);
    background: var(--colors-brand-50, #FCE3F0);
  }

  &__action {
    @apply absolute w-full;
    opacity: 0;
    height: 100%;
    top: 0;
    left: 0;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 16px;

    &-icon {
      width: 64px;
      height: 64px;
      margin: 0 auto;

      &--disabled {
        opacity: 0.5;
      }
    }

    &-title {
      display: block;
      color: #111724;
      text-align: center;
      /* H4 */
      font-family: "GT Walsheim Pro";
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: 32px;

      /* 133.333% */
      &.inactive {
        @apply text-black;
        opacity: .25;
      }
    }

    &-subtitle {
      color: var(--text-brand-500-default, #E10A7B);
      font-family: "GT Walsheim Pro";
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;

      &.inactive {
        @apply text-black;
        opacity: .25;
      }
    }
  }
}
</style>
